import { ContentfulFileType } from './contentful-file.type';
import { ContentfulSysType } from './contentful-sys.type';
import { ContentfulEntryInterface } from './contentful-entry.type';

export class ContentfulAssetType {
  sys: ContentfulSysType;
  fields: {
    title: string,
    file: ContentfulFileType
  };

  constructor(entry: ContentfulEntryInterface) {
    this.sys = entry.hasOwnProperty('sys') ? entry.sys : null;
    this.fields = entry.hasOwnProperty('fields') ? entry.fields : null;
  }

  get title(): string {
    return this.fields['title'];
  }

  get file(): ContentfulFileType {
    return this.fields['file'];
  };
}
